// type IsOnlineFn = () => boolean;

export const isOnline = () => {
  return window.navigator.onLine;
};
